/** Lawsnote のロゴマーク（品牌素材 lawsnote_logo.png を SVG 化したもの）。 */
export function LogoMark({ size = 32 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      aria-hidden="true"
      focusable="false"
      role="presentation"
    >
      <defs>
        <linearGradient id="ln-mark" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="var(--ln-gradient-from)" />
          <stop offset="100%" stopColor="var(--ln-gradient-to)" />
        </linearGradient>
      </defs>
      <circle cx="16" cy="16" r="16" fill="url(#ln-mark)" />
      <path
        d="M10.6 8.4V22.4H20.8"
        fill="none"
        stroke="#fff"
        strokeWidth="2.6"
        strokeLinecap="square"
      />
      <circle cx="18.4" cy="13.4" r="3.1" fill="none" stroke="#fff" strokeWidth="2.4" />
    </svg>
  );
}
